export const LogoDropdown = {
  Logo: {
    pointerEvents: 'none',
    position: 'relative',
    top: 'auto',
    left: 'auto',
    style: { color: 'currentColor' },
    Dropdown: null
  },
  Dropdown: null,
  DropdownArrow: {
    margin: '- W2 - -'
  },
  Dropdown_2: {
    left: '-Z',
    'Dropdown.Logo': {}
  },
  extends: ['CanvasButton', 'DropdownParentFocus'],
  ariaLabel: (el) => el.call('polyglot', 'editor.logoMenu.ariaLabel'),
  flow: 'x',
  round: 'radiusPill',
  align: 'center',
  padding: 'W'
}
